<template>
    <div class="page-car">
        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :span="18">
                    <h2 class="m-b-0">{{carName}}</h2>
                </el-col>
                <el-col :span="6" align="right" v-if="dataTable && dataTable.find(x => x.View.Name === 'CardID')">
                    <el-button
                            class="font-weight-bold"
                            @click="$router.push({ name: 'cardDetails', params: { id: dataTable.find(x => x.View.Name === 'CardID').ObjectId } })"
                            icon="icon-rotate-ccw"
                    >
                        Карта №{{dataTable.find(x => x.View.Name === 'CardID').Value}}
                    </el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="24" :xl="24">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="name" label="">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                {{ scope.row.View.DisplayName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="value" label="">
                        <template slot-scope="scope">
                            <Input2 :itemType="itemType" :value="scope.row.Value" :view="scope.row.View" />
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Input2 from '@/components/Input2'

    export default {
        components: { Input2 },
        data () {
            return {
                itemType: 'Car',
                loading: false,
                total: 0,
                dataTable: [],
                carId: this.$route.params.id,
                carName: ''
            }
        },
        created () {
            this.getData()
        },
        methods: {
            getData () {
                this.loading = true

                let request = {
                    Name: "GetItemView",
                    ItemType: "Car",
                    OperatorName: "Admin",
                    ItemId: this.carId
                }

                this.$api.Main.getCars(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Parameters

                    this.dataTable.map(row => {
                        if (row.View.Name === 'Model') this.carName = row.Value
                    })
                }).catch (() => {
                    this.loading = false
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
